var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.s.isTransparent},[_vm._t("text"),_c('router-link',{attrs:{"to":"/profile"}},[_vm._v("profile settings")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }